/* Brands directory filtering — progressive enhancement only.
   Without JS the page still shows the full A–Z list with working letter anchors;
   category pills fall back to plain #hash links. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.brands-dir');
    if (!root) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('.brands-dir__item'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.brands-dir__group'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('.brands-dir__pill'));
    var letters = Array.prototype.slice.call(root.querySelectorAll('.brands-dir__letters a'));
    var search = root.querySelector('.brands-dir__search');
    var groupsWrap = root.querySelector('.brands-dir__groups');

    var activeCat = '';
    var query = '';

    // keep the sticky letter nav offset in sync with the sticky pills row height
    var pillsRow = root.querySelector('.brands-dir__pills');
    function setPillsHeight() {
      if (pillsRow) root.style.setProperty('--brands-pills-h', pillsRow.offsetHeight + 'px');
    }
    setPillsHeight();
    window.addEventListener('resize', setPillsHeight);

    var empty = document.createElement('p');
    empty.className = 'brands-dir__empty';
    empty.hidden = true;
    empty.textContent = 'No brands match — try a different search or category.';
    if (groupsWrap) groupsWrap.appendChild(empty);

    function norm(s) {
      s = (s || '').toLowerCase();
      try {
        s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      } catch (e) { /* older browsers */ }
      return s;
    }

    function apply() {
      var visible = 0;
      items.forEach(function (li) {
        var okCat = !activeCat ||
          (' ' + (li.getAttribute('data-cats') || '') + ' ').indexOf(' ' + activeCat + ' ') !== -1;
        var okQuery = !query || norm(li.getAttribute('data-name')).indexOf(query) !== -1;
        var show = okCat && okQuery;
        li.hidden = !show;
        if (show) visible++;
      });
      groups.forEach(function (g) {
        g.hidden = !g.querySelector('.brands-dir__item:not([hidden])');
      });
      letters.forEach(function (a) {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        a.classList.toggle('is-empty', !target || target.hidden);
      });
      empty.hidden = visible !== 0;
    }

    function setCategory(cat, updateHash) {
      activeCat = cat || '';
      pills.forEach(function (p) {
        p.classList.toggle('is-active', (p.getAttribute('data-cat') || '') === activeCat);
      });
      apply();
      if (updateHash && window.history && history.replaceState) {
        history.replaceState(null, '',
          activeCat ? '#' + activeCat : window.location.pathname + window.location.search);
      }
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function (e) {
        e.preventDefault();
        setCategory(p.getAttribute('data-cat') || '', true);
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        query = norm(search.value.trim());
        apply();
      });
    }

    // Deep links: /pages/brands#surfboards pre-applies the category filter;
    // letter hashes (#letter-a) fall through to native anchor scrolling.
    var hash = window.location.hash.slice(1);
    if (hash) {
      var isCat = pills.some(function (p) { return p.getAttribute('data-cat') === hash; });
      if (isCat) setCategory(hash, false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
